import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ClosedCaptionIcon(props: IconProps) {
    return <Icon {...props} iconKey={"closed_caption"}/>
}
